import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Gift } from "lucide-react";

export default function LoyaltyCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/loyalty/me").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const progress = s.paid_sessions % s.every;
  return (
    <div className="mt-6 sc-card" data-testid="loyalty-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><Gift className="w-5 h-5 text-rose-500" /> Programme fidélité</h2>
          <p className="text-sm text-slate-600 mt-1">Toutes les {s.every} séances réglées, votre séance suivante est à <b>-{s.percent} %</b> (appliqué automatiquement au paiement).</p>
        </div>
        {s.credits > 0 && <span data-testid="loyalty-credits" className="text-sm font-bold px-3 py-1.5 rounded-full bg-rose-500 text-white">{s.credits} récompense(s) à utiliser</span>}
      </div>
      <div className="mt-3 flex items-center gap-1.5" data-testid="loyalty-progress">
        {[...Array(s.every)].map((_, i) => <div key={i} className={`h-3 flex-1 rounded-full ${i < progress ? "bg-rose-500" : "bg-slate-200"}`} />)}
      </div>
      <div className="mt-1.5 text-xs text-slate-500">{s.paid_sessions} séance(s) réglée(s) · {s.credits > 0 ? "Récompense disponible !" : `encore ${s.next_in} séance(s) avant votre prochaine réduction`}</div>
    </div>
  );
}
